export function replaceVariables(content: string, replacements: Object) {
	return content.replace(/\{(\w+)\}/g, (_match, variable) => {
		return replacements[variable] || variable
	})
}
